import {action, computed, observable, runInAction, toJS} from "mobx"
import {Gate} from "./lib/gate/Gate"
import {Action, History, Location} from "history"
import {User, Visitor} from "./lib/gate/interfaces"
import {Form, FormID} from "./interfaces"
import {route} from "./lib/functions/route"
import {DataStore} from "./data/DataStore"
import {EventDispatcher} from "./lib/gate/EventDispatcher"
import Swal from "sweetalert2"
import {
    removeJsonDataForms,
    FORM_ENROLLMENT_APPLICATION_SIZE,
    APPLICATION_TO_ENROLL,
    APPLICATION_PRIOR_TO_ENROLL,
    currentSizeForm,
    ALL_FORMS,
    hasAllFormsInSectionPriorToEnroll
} from "./helper/Methods"

const forms: Form[] = [
    {
        form_id: "application_career_information",
        title: "APPLICATION / CAREER INFORMATION",
        type: "web",
        enabled: true
    },
    {
        form_id: "enrollment_application",
        title: "Enrollment Application",
        type: "pdf",
        enabled: true
    },
    {
        form_id: "application_prior_to_enroll",
        title: "Prior to enroll",
        type: "web",
        enabled: true
    },
    {
        form_id: "pre_enrollment_info",
        title: "Pre Enrollment Info",
        type: "pdf",
        enabled: true
    },
    {
        form_id: "request_accommodations",
        title: "Request for Reasonable Accommodations",
        type: "pdf",
        enabled: true
    },
    {
        form_id: "safety_security_questionnaire",
        title: "Safety and Security Questionnaire",
        type: "pdf",
        enabled: true
    },
    {
        form_id: "occupational_qualifications",
        title: "Occupational Qualifications Fact Sheet",
        type: "pdf",
        enabled: true
    },
    {
        form_id: "pdf_catalog",
        title: "Catalog Student",
        type: "web",
        enabled: false
    },
    {
        form_id: "application_ready_to_enroll",
        title: "Ready to enroll",
        type: "web",
        enabled: true
    },
    {
        form_id: "student_information",
        title: "Student Information",
        type: "pdf",
        enabled: true
    },
    {
        form_id: "text_kit_contract",
        title: "Textbook and Kit disclosure sign off",
        type: "pdf",
        enabled: true
    },
    {
        form_id: "i_understand_form",
        title: "I Understand Form",
        type: "pdf",
        enabled: true
    },
    {
        form_id: "electronic_learning_policy",
        title: "Electronic Learning Policy",
        type: "pdf",
        enabled: true
    },
    {
        form_id: "photo_video_release_form",
        title: "Photo/Video Release Form",
        type: "pdf",
        enabled: true
    },
    {
        form_id: "electronic_signature_policy",
        title: "Electronic Signature Policy",
        type: "pdf",
        enabled: true
    },
    {form_id: "medical_marijuana", title: "Medical Marijuana Policy", type: "pdf", enabled: true},
    {form_id: "drug_review_receipt", title: "Drug Review Receipt", type: "pdf", enabled: true},
    {form_id: "policy_truth_candor", title: "Policy Truth & Candor", type: "pdf", enabled: true},
    {
        form_id: "biometric_privacy_policy",
        title: "Biometric Privacy Policy",
        type: "pdf",
        enabled: true
    },
    {
        form_id: "student_handbook",
        title: "Student Handbook/Orientation Checklist",
        type: "pdf",
        enabled: true
    },
    {
        form_id: "pdf_handbook",
        title: "Student Handbook",
        type: "web",
        enabled: false
    },
    {form_id: "annual_notice", title: "Annual Notice", type: "pdf", enabled: true},
    {
        form_id: "pdf_consumer_info",
        title: "Consumer Information",
        type: "web",
        enabled: false
    },
    {
        form_id: "authorization_research",
        title: "Authorization Research",
        type: "pdf",
        enabled: true
    },
    {
        form_id: "ipeds",
        title: "IPEDS/College Navigator Acknowledgement of Receipt",
        type: "pdf",
        enabled: true
    },
    {
        form_id: "security_disclosure_report",
        title: "Campus Security Disclosure/Annual Security Report (ASR)",
        type: "pdf",
        enabled: true
    },
    {
        form_id: "distance_education_policy",
        title: "Distance Education Policy",
        type: "pdf",
        enabled: true
    },
    {
        form_id: "application_upload_docs",
        title: "Application Upload docs",
        type: "web",
        enabled: false
    },
    {
        form_id: "submission",
        title: "submission",
        type: "web",
        enabled: true
    }
]

const tabs = [
    {
        id: "1",
        tab_id: "career_information",
        title: "Career Information",
        tabletTitle: "Career Info",
        items: [
            {
                label: "Program Selection",
                value: "application_career_information"
            }
        ],
        disabled: false
    },
    {
        id: "2",
        tab_id: "application",
        title: "Application",
        tabletTitle: "Application",
        items: [{value: "enrollment_application", label: "Enrollment Application"}],
        disabled: false
    },
    {
        id: "3",
        tab_id: "prior_to_enroll",
        title: "Prior to enroll",
        tabletTitle: "Prior to enroll",
        items: [
            {value: "application_prior_to_enroll", label: "Prior to enroll"},
            {value: "pre_enrollment_info", label: "Pre Enrollment Info"},
            {value: "request_accommodations", label: "Request for Reasonable Accommodations"},
            {value: "safety_security_questionnaire", label: "Safety and Security Questionnaire"},
            {value: "occupational_qualifications", label: "Occupational Qualifications Fact Sheet"},
            {value: "pdf_catalog", label: "Student Catalog"}
        ],
        disabled: true
    },
    {
        id: "4",
        tab_id: "ready_to_enroll",
        title: "Ready to enroll",
        tabletTitle: "Ready to enroll",
        items: [{value: "application_ready_to_enroll", label: "Ready to enroll"}],
        disabled: true
    },
    {
        id: "5",
        tab_id: "enrollment_docs",
        title: "Enrollment Docs",
        tabletTitle: "Enrollment Docs",
        items: [
            {
                value: "student_information",
                label: "Student Information"
            },
            {value: "text_kit_contract", label: "Textbook and Kit disclosure sign off"}
        ],
        disabled: true
    },
    {
        id: "6",
        tab_id: "disclosures",
        title: "Disclosures",
        tabletTitle: "Disclosures",
        items: [
            {
                value: "i_understand_form",
                label: "I Understand Form"
            },
            {
                value: "electronic_learning_policy",
                label: "Electronic Learning Policy"
            },
            {
                value: "photo_video_release_form",
                label: "Photo/Video Release Form"
            },
            {value: "electronic_signature_policy", label: "Electronic Signature Policy"},
            {value: "medical_marijuana", label: "Medical Marijuana Policy"},
            {value: "drug_review_receipt", label: "Drug Review Receipt"},
            {value: "policy_truth_candor", label: "Policy Truth & Candor"},
            {value: "biometric_privacy_policy", label: "Biometric Privacy Policy"},
            {value: "student_handbook", label: "Student Handbook/Orientation Checklist"},
            {value: "pdf_handbook", label: "Student Handbook"},
            {value: "annual_notice", label: "Annual Notice"},
            {value: "pdf_consumer_info", label: "Consumer Information"}
        ],
        disabled: true
    },
    {
        id: "7",
        tab_id: "additional_docs",
        title: "Additional Docs",
        tabletTitle: "Additional Docs",
        items: [
            {value: "authorization_research", label: "Authorization Research"},
            {value: "ipeds", label: "IPEDS/College Navigator Acknowledgement of Receipt"},
            {
                value: "security_disclosure_report",
                label: "Campus Security Disclosure/Annual Security Report (ASR)"
            },
            {
                value: "distance_education_policy",
                label: "Distance Education Policy"
            },
            {
                value: "application_upload_docs",
                label: "Upload docs"
            }
        ],
        disabled: true
    },
    {
        id: "8",
        tab_id: "submission",
        title: "Submission",
        tabletTitle: "Submission",
        items: [
            {
                label: "Submission",
                value: "submission"
            }
        ],
        disabled: true
    }
]

export class Model {
    public dispatcher = new EventDispatcher()
    public dispatcher2 = new EventDispatcher()
    private validateFunctions: Function[] = []
    private DISABILITY_YES = "yes"

    @observable
    public document: UserDocument = {json_data: {}}

    @observable
    public signaturePopup: {
        show: boolean
        signature_key
        mode: "signature" | "initials" | "parent"
    } = {
        show: false,
        signature_key: "",
        mode: "signature"
    }

    @observable
    private form_id: FormID = "application_career_information"

    @observable
    public iframeLoaded = false

    @observable
    public campusInformationFooter = {
        name: "",
        address: "",
        state: "",
        phone: ""
    }

    @observable
    public location: Location

    @observable
    public path: string

    @observable
    public visitor: Visitor

    @observable
    public user: User | undefined

    @observable
    public appSettings: any

    @observable
    public popup = {visible: false, message: ""}

    public childBridge: any

    @observable
    public is_form_submitted = false

    private parentBridge: any

    @observable
    public careerInfo: any

    @observable
    public campusesInfo: any

    public STAGES_TABS_IDS = [
        "career_information",
        "application",
        "prior_to_enroll",
        "ready_to_enroll",
        "enrollment_docs",
        "disclosures",
        "additional_docs",
        "submission"
    ]

    public COLOR_STAGES = [
        "application",
        "priorToEnroll",
        "readyToEnroll",
        "others",
        "disabledTabs"
    ]

    constructor(public gate: Gate, private history: History, public dataStore: DataStore) {
        this.history = history
        history.listen(this.onHistoryChange.bind(this))
        this.onHistoryChange(history.location, "PUSH") // execute one time
        // @ts-ignore
        this.parentBridge = window.parent.bridge
    }

    public updatePdfView() {
        let json_data
        if (this.form.type === "pdf") {
            if (!this.childBridge) {
                throw new Error("No childBridge! Please check bridge set in admissions-pdf")
            }

            json_data = this.childBridge.json_data
            this.document.json_data = json_data
            this.dispatcher.dispatch()
        }
    }

    public enableForm(form_id: FormID) {
        for (let form of forms) {
            if (form.form_id === form_id) {
                form.enabled = true
                break
            }
        }

        this.dispatcher.dispatch()
    }

    public disableForm(form_id: FormID) {
        for (let form of forms) {
            if (form.form_id === form_id) {
                form.enabled = false
                break
            }
        }
        this.dispatcher.dispatch()
    }

    public enableTabs(tab_id: string) {
        for (let tab of tabs) {
            if (tab.tab_id === tab_id) {
                tab.disabled = false
                break
            }
        }
        this.dispatcher.dispatch()
    }

    public disableTabs(tab_id: string) {
        for (let tab of tabs) {
            if (tab.tab_id === tab_id) {
                tab.disabled = true
                break
            }
        }
        this.dispatcher.dispatch()
    }

    @action
    public setFormId(id: FormID) {
        console.log("SET FORM ID=", id)
        // this.form_id = id
        this.goTo(`/form/${id}?token=${this.gate.getToken()}&user_id=${this.user?.id}`)
        this.iframeLoaded = false
    }

    @computed
    public get form(): Form {
        return forms.find((el) => {
            return el.form_id === this.form_id
        })
    }

    public goTo(url: string) {
        console.log(`GO TO URL:${url}`)
        this.history.push(url)
    }

    public getTabs(): any {
        return tabs
    }

    public getForms(): Form[] {
        return forms
    }

    public get enabledItems(): FormID[] {
        let arr = forms.filter((el) => {
            return el.enabled
        })

        return arr.map((el: Form) => {
            return el.form_id
        })
    }

    public getPreviousFormId(): FormID {
        let index: number
        for (let i = 0; i < forms.length; i++) {
            if (forms[i].form_id === this.form_id) {
                index = i
                break
            }
        }
        if (index === 0) {
            return null
        }

        for (let i = index - 1; i >= 0; i--) {
            if (forms[i].enabled) {
                return forms[i].form_id
            }
        }

        return null
    }

    public getFormId(): FormID {
        return this.form_id
    }

    public getNextFormId(): FormID {
        let index: number
        for (let i = 0; i < forms.length; i++) {
            if (forms[i] && forms[i].form_id === this.form_id) {
                index = i
                break
            }
        }

        if (index + 1 === forms.length) {
            return null
        }

        for (let i = index + 1; i < forms.length; i++) {
            if (forms[i].enabled) {
                return forms[i].form_id
            }
        }

        return null
    }

    public checkByStages(style: any, disabled: boolean, tab_id: string) {
        const [
            career_information,
            application,
            prior_to_enroll,
            ready_to_enroll
        ] = this.STAGES_TABS_IDS //, enrollment_docs, disclosures, additional_docs, submission
        const [
            applicationColor,
            priorToEnrollColor,
            readyToEnrollColor,
            othersColor,
            disabledTabs
        ] = this.COLOR_STAGES
        if (disabled) {
            return style[disabledTabs]
        } else if (tab_id === career_information || tab_id === application) {
            return style[applicationColor]
        } else if (tab_id === prior_to_enroll) {
            return style[priorToEnrollColor]
        } else if (tab_id === ready_to_enroll) {
            return style[readyToEnrollColor]
        } else {
            //if(tab_id === enrollment_docs || tab_id === disclosures || tab_id === additional_docs || tab_id === submission)
            return style[othersColor]
        }
    }

    private onHistoryChange(location: Location, action: Action) {
        this.path = location.pathname
        this.location = location
        console.log("ON HISTORY Change=", this.path)
        if (route("/form/:id(/)", this.path)) {
            // regex
            const {id} = route("/form/:id(/)*", this.path)
            this.form_id = id
        }
    }

    @computed
    public get planStaffUserId(): number {
        if (this.appSettings && this.appSettings.plan_staff_user_id) {
            return parseInt(this.appSettings.plan_staff_user_id)
        }

        return 0
    }

    @computed
    public get agreementStaffUserId(): number {
        // return 60347
        if (this.appSettings && this.appSettings.agreement_staff_user_id) {
            return parseInt(this.appSettings.agreement_staff_user_id)
        }

        return 0
    }

    @action
    public alert(message: string) {
        this.popup.visible = true
        this.popup.message = message
    }

    public get isStaff(): boolean {
        if (!this.visitor) {
            return false
        }
        const role = this.visitor.role
        if (role === "staff" || role === "admin") {
            return true
        }

        return false
    }

    public async checkPriorCampusCode({type}) {
        let json_data
        json_data = this.document.json_data
        let {success} = await this.gate.request(`/check/${this.user.id}`, {
            data: {json_data, type}
        })

        if (success) {
            json_data.isValidPriorCampusCode = true
            await Swal.fire({
                icon: "success",
                title: `Valid campus code`,
                text: `Thank you! You may now proceed to the next section.`
            })
            const isSuccess = await this.savePriorAndContinue()
            if (isSuccess) {
                const form_id: FormID = this.getNextFormId()
                if (form_id) {
                    this.setFormId(form_id)
                }
            }
        } else {
            delete json_data.isValidPriorCampusCode
            await Swal.fire({
                icon: "error",
                title: `Invalid campus code`,
                text: `You may have an invalid campus code. Please Try again.`
            })
        }
        return success
    }

    public async checkCampusCode({type}) {
        let json_data
        json_data = this.document.json_data
        let {success} = await this.gate.request(`/check/${this.user.id}`, {
            data: {json_data, type}
        })

        if (success) {
            json_data.isValidCampusCode = true
            await Swal.fire({
                icon: "success",
                title: `Valid campus code`,
                text: `Thank you! You may now proceed to the next section.`
            })
            const isSuccess = await this.saveAndContinue()
            if (isSuccess) {
                const form_id: FormID = this.getNextFormId()
                this.setFormId(form_id)
            }
        } else {
            delete json_data.isValidCampusCode
            await Swal.fire({
                icon: "error",
                title: `Invalid campus code`,
                text: `You may have an invalid campus code. Please Try again.`
            })
        }
        return success
    }

    public async loadAppSettings() {
        let r = await this.gate.request("/app-settings/get")
        this.appSettings = r.data.json_data
    }

    public async loadMe(): Promise<void> {
        let r = await this.gate.request("/users/get-me")
        if (!r.success) {
            this.alert("API Error!" + JSON.stringify(r.errors))
        }
        this.visitor = r.data
    }

    public async loadUser(user_id: number): Promise<void> {
        let r = await this.gate.request(`/users/${user_id}/get`)
        this.user = r.data
    }

    public async loadCareerInformation(): Promise<void> {
        const {data} = await this.gate.request(`/careers`)
        this.careerInfo = data
    }

    public async loadCampuses(): Promise<void> {
        const {data} = await this.gate.request(`/campuses`)
        this.campusesInfo = data
    }

    public getHistory(): History {
        return this.history
    }

    public async priorToEnrollStudent(): Promise<void> {
        let json_data
        json_data = this.document.json_data
        try {
            const responseSubmit = await this.gate.request(`/users/${this.user.id}/enroll/prior`)
            if (responseSubmit.success) {
                await Swal.fire({
                    icon: "success",
                    title: `Thank you to complete the Prior to Enroll Documents`,
                    html: `
                        <p>
                            Your admissions advisor will be in contact with you soon to provide you with the 
                            <strong>Seccond Campus Code</strong> to access and complete the remaining enrollment documents.
                        </p>
                    `,
                    willClose: () => {
                        if (responseSubmit.data.doc.json_data.isPriorToEnrollSendEmail) {
                            json_data.isPriorToEnrollSendEmail = true
                            this.dispatcher.dispatch()
                            this.dispatcher2.dispatch()
                        }
                    }
                })
            } else {
                delete json_data.isSubmitted
                delete json_data.isPriorToEnrollSendEmail
            }
        } catch (error) {
            delete json_data.isSubmitted
            delete json_data.isPriorToEnrollSendEmail
        }
        runInAction(() => {
            this.is_form_submitted = true
        })
    }

    public async preEnrollStudent(): Promise<void> {
        let json_data
        json_data = this.document.json_data
        try {
            const responseSubmit = await this.gate.request(`/users/${this.user.id}/enroll`)
            if (responseSubmit.success) {
                await Swal.fire({
                    icon: "success",
                    title: `Thank you for completing your Enrollment Application`,
                    html: `
                        <p>
                            Your admissions advisor will be in contact with you soon to provide you with the 
                            <strong>Campus Code</strong> to access and complete other enrollment documents.
                        </p>
                    `
                })
            } else {
                delete json_data.isSubmitted
            }
        } catch (error) {}
        runInAction(() => {
            this.is_form_submitted = true
        })
    }

    public async submit(): Promise<void> {
        let json_data
        json_data = this.document.json_data
        const id = this.user.doc.id
        try {
            json_data.isSubmitted =
                ALL_FORMS.length === currentSizeForm(json_data.forms || [], ALL_FORMS)

            const responseSave = await this.gate.request(`/docs/${id}/edit`, {
                data: {json_data}
            })
            if (responseSave.success) {
                const responseSubmit = await this.gate.request(`/users/${this.user.id}/submit`)
                if (responseSubmit.success) {
                    await Swal.fire({
                        icon: "success",
                        title: `Thank you for completing the Enrollment Documents.`,
                        text: `TSPA Advisor will contact you soon.`
                    })
                } else {
                    delete json_data.isSubmitted
                }
            }
        } catch (error) {
            delete json_data.isSubmitted
        }
        runInAction(() => {
            this.is_form_submitted = true
        })
    }

    public async saveAgreement(): Promise<boolean> {
        let json_data
        const id = this.user.doc.id
        if (this.form.type === "web") {
            // if (!this.validate()) {
            //     return false
            // }

            json_data = this.document.json_data
        }

        if (!json_data) {
            return false
        }
        json_data.accepted = true
        let r: any = await this.gate.request(`/docs/${id}/edit`, {
            data: {json_data}
        })
        if (r.success) {
            const {
                data: {
                    json_data: {accepted}
                }
            } = r

            json_data.accepted = accepted
        } else {
            if (json_data.accepted) {
                delete json_data.accepted
            }
        }

        return r.success
    }

    public async savePriorAndContinue(): Promise<boolean> {
        let json_data
        if (this.form.type === "pdf") {
            if (!this.childBridge) {
                throw new Error(
                    "No childBridge! Please check bridge set in admissions-tspanampa-pdf"
                )
            }
            if (!(await this.childBridge.validate())) {
                return false
            }
            json_data = this.childBridge.json_data
            this.document.json_data = json_data
            this.dispatcher.dispatch()
        }
        console.log("childBridge", this.childBridge)

        if (this.form.type === "web") {
            if (!this.validate()) {
                return false
            }

            json_data = this.document.json_data
        }

        if (!json_data) {
            return false
        }

        json_data.forms = json_data.forms || {}
        json_data.forms[this.form.form_id] = this.form

        if (
            this.form_id === APPLICATION_PRIOR_TO_ENROLL &&
            json_data.isValidPriorCampusCode &&
            json_data.isEnrollmentApplicationDocReady
        ) {
            json_data.hasPriorCampusCode = true
        }
        try {
            const id = this.user.doc.id

            let r: any = await this.gate.request(`/docs/${id}/edit`, {
                data: {json_data}
            })
            if (r.success) {
                this.dispatcher2.dispatch()
            }
            return r.success
        } catch (error) {
            console.log("Internal server error while saving/logout the doc.", error)
            delete json_data.hasPriorCampusCode
            return error
        }
    }

    public async saveAndContinueWithReadyToEnroll(): Promise<boolean> {
        let json_data
        if (this.form.type === "pdf") {
            if (!this.childBridge) {
                throw new Error(
                    "No childBridge! Please check bridge set in admissions-tspanampa-pdf"
                )
            }
            if (!(await this.childBridge.validate())) {
                return false
            }
            json_data = this.childBridge.json_data
            this.document.json_data = json_data
            this.dispatcher.dispatch()
        }
        console.log("childBridge", this.childBridge)

        if (this.form.type === "web") {
            if (!this.validate()) {
                return false
            }

            json_data = this.document.json_data
        }

        if (!json_data) {
            return false
        }

        json_data.forms = json_data.forms || {}
        json_data.forms[this.form.form_id] = this.form
        try {
            const id = this.user.doc.id

            let r: any = await this.gate.request(`/docs/${id}/edit`, {
                data: {json_data}
            })
            // data: {json_data: jsonDataSubmit}
            if (r.success) {
                if (
                    hasAllFormsInSectionPriorToEnroll(json_data.forms) &&
                    !r.data.json_data.isPriorToEnrollSendEmail
                ) {
                    await this.priorToEnrollStudent()
                }
                // await this.syncWithCampusLogin()
            }
            return r.success
        } catch (error) {
            console.log("Internal server error while saving upload docs section.", error)
            delete json_data.isPriorToEnrollSendEmail
            return error
        }
    }

    public async saveAndContinue(): Promise<boolean> {
        let json_data
        if (this.form.type === "pdf") {
            if (!this.childBridge) {
                throw new Error(
                    "No childBridge! Please check bridge set in admissions-tspanampa-pdf"
                )
            }
            if (!(await this.childBridge.validate())) {
                return false
            }
            json_data = this.childBridge.json_data
            this.document.json_data = json_data
            this.dispatcher.dispatch()
        }
        console.log("childBridge", this.childBridge)

        if (this.form.type === "web") {
            if (!this.validate()) {
                return false
            }

            json_data = this.document.json_data
        }

        if (!json_data) {
            return false
        }

        json_data.forms = json_data.forms || {}
        json_data.forms[this.form.form_id] = this.form
        console.log("Saving and logout form:", this.form_id)
        if (
            this.form_id === APPLICATION_TO_ENROLL &&
            json_data.isValidCampusCode &&
            json_data.isEnrollmentApplicationDocReady
        ) {
            json_data.hasCampusCode = true
        }
        try {
            const id = this.user.doc.id

            let r: any = await this.gate.request(`/docs/${id}/edit`, {
                data: {json_data}
            })
            if (r.success) {
                this.dispatcher2.dispatch()
            }
            return r.success
        } catch (error) {
            console.log("Internal server error while saving/logout the doc.", error)
            delete json_data.hasCampusCode
            return error
        }
    }

    public async updateDocumentUpload(): Promise<boolean> {
        let json_data
        json_data = this.document.json_data
        if (!json_data) {
            return false
        }
        json_data.forms = json_data.forms || {}
        json_data.forms[this.form.form_id] = this.form
        try {
            const id = this.user.doc.id

            let r: any = await this.gate.request(`/docs/${id}/edit`, {
                data: {json_data}
            })
            return r.success
        } catch (error) {
            console.log("Internal server error while saving the doc.", error)
            return error
        }
    }

    public async save(): Promise<boolean> {
        let json_data
        if (this.form.type === "pdf") {
            if (!this.childBridge) {
                throw new Error(
                    "No childBridge! Please check bridge set in admissions-tspanampa-pdf"
                )
            }
            if (!(await this.childBridge.validate())) {
                await Swal.fire({
                    icon: "error",
                    title: "There are some errors.",
                    text: "Please take a look."
                })
                return false
            }
            json_data = this.childBridge.json_data
            this.document.json_data = json_data
            this.dispatcher.dispatch()
        }
        console.log("childBridge", this.childBridge)

        if (this.form.type === "web") {
            if (!this.validate()) {
                return false
            }

            json_data = this.document.json_data
        }

        if (!json_data) {
            return false
        }

        json_data.forms = json_data.forms || {}
        json_data.forms[this.form.form_id] = this.form

        const APPLICATION_CAREER_INFORMATION: FormID = "application_career_information"
        const ENROLLMENT_APPLICATION: FormID = "enrollment_application"
        console.log("my current JSON DATA:", toJS(json_data), this.form_id)

        if (APPLICATION_CAREER_INFORMATION === this.form_id) {
            try {
                const {
                    tuition_data,
                    schedule_data,
                    spf_data,
                    opt_out_data,
                    condition_text_data
                } = await this.generateTuituonByCampusAndProgram(json_data)
                json_data.extra.tuitionInfo = tuition_data
                json_data.extra.optOutInfo = opt_out_data
                json_data.extra.scheduleInfo = schedule_data
                json_data.extra.spfInfo = spf_data
                json_data.extra.conditionTextInfo = condition_text_data
                const currentForms = json_data.forms
                json_data.forms = removeJsonDataForms(currentForms || [])
            } catch (error) {
                console.log(`Something happens while get tuitions: ${error}`)
            }
            console.log("another JSON data:", toJS(json_data.extra.spfInfo))
            delete json_data.staff_bio
            delete json_data.staff_electronic
            delete json_data.staff_acomodation
            delete json_data.staff
        }

        // if (ENROLLMENT_APPLICATION === this.form_id && !json_data.isEnrollmentApplicationDocReady) {
        //     json_data.isEnrollmentApplicationDocReady = true
        // }
        console.log("Saving form:", this.form_id)
        try {
            const id = this.user.doc.id

            let r: any = await this.gate.request(`/docs/${id}/edit`, {
                data: {json_data}
            })
            if (r.success) {
                const {
                    success,
                    data: {json_data: jsonDataSubmit}
                } = r
                const sizeForms = Object.keys(jsonDataSubmit.forms)
                const isEnrollmentApplicationReadyToEnroll =
                    !json_data.isEnrollmentApplicationDocReady &&
                    (sizeForms.length === FORM_ENROLLMENT_APPLICATION_SIZE ||
                        sizeForms.length === FORM_ENROLLMENT_APPLICATION_SIZE + 1) &&
                    sizeForms.includes(ENROLLMENT_APPLICATION) &&
                    ENROLLMENT_APPLICATION === this.form_id
                if (success && isEnrollmentApplicationReadyToEnroll) {
                    try {
                        await this.preEnrollStudent()
                        await this.syncWithCampusLogin()
                        json_data.isEnrollmentApplicationDocReady = true
                        this.dispatcher2.dispatch()
                    } catch (error) {
                        delete json_data.isEnrollmentApplicationDocReady
                    }
                }
                // await this.syncWithCampusLogin()
            }
            return r.success
        } catch (error) {
            console.log("Internal server error while saving the doc.", error)
            return error
        }
    }
    private summarizeCosts(dataMatrix: Array<any>, keyField: string): number {
        const totalObject = dataMatrix.reduce(
            (acumulator, currentValue) => ({
                [keyField]: acumulator[keyField] + currentValue[keyField]
            }),
            {[keyField]: 0}
        )
        const {[keyField]: total} = totalObject
        return total
    }
    private async updateTuition(jsonData) {
        const {
            extra: {
                tuitionInfo: {id, tuition}
            }
        } = jsonData
        const tuitionResponse = await this.gate.request(`/tuitions/${id}/edit`, {data: tuition})
        const {
            data: {tuition_data}
        } = tuitionResponse
        return tuition_data
    }

    private async updateSPFTable(jsonData) {
        const {
            extra: {
                spfInfo: {id, spf: spfJsonData}
            }
        } = jsonData
        const spfResponse = await this.gate.request(`/spfs/${id}/edit`, {data: spfJsonData})
        const {data} = spfResponse
        return data
    }

    public async syncWithCampusLogin(): Promise<any> {
        console.log("sync")
        return await this.gate.request(`/campus/login/sync`)
    }

    private async generateTuituonByCampusAndProgram(jsonData) {
        const {
            extra: {
                campus: {id: campusId},
                program: {id: programId}
            }
        } = jsonData
        const careerResponse = await this.gate.request(
            `/careers/campuses/${campusId}/programs/${programId}/get`
        )
        const {
            data: {tuition_data, schedule_data, spf_data, opt_out_data, condition_text_data}
        } = careerResponse
        console.log("response by campus & program:", careerResponse)

        return {tuition_data, schedule_data, spf_data, opt_out_data, condition_text_data}
    }

    public async uploadDocument(file: File, id: string) {
        const IS_MULTI = false
        const formData = new FormData()
        formData.append(id, file)
        const data = await this.gate.request(
            `/uploads`,
            {
                data: formData
            },
            IS_MULTI
        )
        return data
    }

    public async signOut() {
        const json_data = this.document.json_data
        if (json_data.isSubmitted) {
            delete json_data.isSubmitted
            const id = this.user.doc.id
            await this.gate.request(`/docs/${id}/edit`, {
                data: {json_data}
            })
        }
        this.parentBridge.signOut()
    }

    public async getSignature(type: "signature" | "initials" | "parent"): Promise<object | null> {
        if (!this.currentSignature) {
            let r = await this.gate.request("/signatures/get-my", {data: {type: type}})
            if (r.success) {
                this.currentSignature = r.data
            } else {
                this.currentSignature = null
            }
        }

        return this.currentSignature
    }

    public addValidateFunction(f: Function) {
        for (let item of this.validateFunctions) {
            if (item === f) {
                return
            }
        }

        this.validateFunctions.push(f)
    }

    public removeValidateFunction(f: Function) {
        console.log("removeValidateFunction")
        // @ts-ignore
        console.log(f.functionId)

        console.log(
            this.validateFunctions.map((e) => {
                // @ts-ignore
                return e.functionId
            })
        )
        for (let i = 0; i < this.validateFunctions.length; i++) {
            // @ts-ignore
            if (this.validateFunctions[i].functionId === f.functionId) {
                this.validateFunctions.splice(i, 1)
                console.log(
                    this.validateFunctions.map((e) => {
                        // @ts-ignore
                        return e.functionId
                    })
                )
                return
            }
        }
    }

    public validate(): boolean {
        console.log("onValidate:", this.validateFunctions)
        let results = []
        for (let f of this.validateFunctions) {
            const r = f()
            results.push(r)
        }

        if (results.includes(false)) {
            return false
        }
        return true
    }

    public async loadVisitor() {
        let r = await this.gate.request("/users/get-me")
        this.visitor = r.data
    }

    public async loadAll(token: string, user_id: number) {
        if (!token || !user_id) {
            return
        }
        this.gate.setToken(token)
        await Promise.all([
            this.loadUser(user_id),
            this.loadVisitor(),
            this.loadCareerInformation(),
            this.loadCampuses()
        ]) // add a control to view if we have campus selected & program selected to refill tuition

        this.document = this.user.doc
        console.log("MODEL>LOAD ALL")
        console.log(toJS(this.document))
        this.form_id =
            (this.document.json_data.progress as FormID) || "application_career_information"

        if (!this.document.json_data.role) {
            this.document.json_data.role = this.user.role
        }
        if (!this.document.json_data.first_name) {
            this.document.json_data.first_name = this.user.first_name
        }
        if (!this.document.json_data.last_name) {
            this.document.json_data.last_name = this.user.last_name
        }

        if (!this.document.json_data.home_phone) {
            this.document.json_data.home_phone = this.user.json_data.phone_number
        }

        if (!this.document.json_data.full_name) {
            this.document.json_data.full_name = `${this.user.first_name} ${this.user.last_name}`
        }
        if (!this.document.json_data.email) {
            this.document.json_data.email = `${this.user.email}`
        }
        if (!this.document.json_data.about_us) {
            this.document.json_data.about_us = `${this.user.json_data.about_us}`
        }
        if (!this.document.json_data.about_us_text) {
            this.document.json_data.about_us_text = `${this.user.json_data.about_us_text}`
        }

        console.log("autopopulate", toJS(this.document))

        this.dispatcher.dispatch()
        this.dispatcher2.dispatch()
    }

    public async deleteSupportedDocument(id: number) {
        const r = await this.gate.request(`/uploads/${id}/delete`)
        return r
    }

    private currentSignature
}

export interface SignatureVO {
    id
    user_id
    json_data: {
        img: string
    }
    ip // "172.17.0.1"
    created_at // "2019-10-17T11:22:43.823Z"
    updated_at // "2019-10-17T11:22:43.823Z"
    deleted_at
}

interface UserDocument {
    id?: number
    // pack_id
    // visitor_id
    // user_id
    // user: User
    // type
    json_data: JsonDocument
    // created_at
    // updated_at
    // deleted_at
}

export interface JsonDocument {
    [key: string]: string | any
}

export interface CareerDocument {
    [key: string]: any
}
